import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import GeoLocationService from '@/services/GeoLocationService';

/**
 * Factory function to return a function to update lat-long of a given object
 * @returns the function to update the lat-long of the given object
 */
export function useUpdateGeoLocation() {
  const { t } = useI18n({ useScope: 'global' });
  const store = useStore();

  const updateGeoLocation = async function(obj, store_update_method) {
    if ((obj.lat) && (obj.long)) {
      if (!confirm(t('confirm_overwrite_geo'))) {
        return;
      }
    }
  
    GeoLocationService.getPosition().then(function (resp) {
      console.log("Inside update_geo_location, onGeoLocation(), resp ==> ", resp);
      obj.lat = resp.coords.latitude;
      obj.long = resp.coords.longitude;
      store.dispatch(store_update_method, obj);
      alert(t("geo_location_success"));
    }).catch((err) => {
      console.error(err.message);
      alert(t("geo_location_error") + ": " + err.message);
    });     
  }

  return updateGeoLocation
}